import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _BlankAltLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M12.172 21H9c-1.886 0-2.828 0-3.414-.586S5 18.886 5 17V7c0-1.886 0-2.828.586-3.414S7.114 3 9 3h6c1.886 0 2.828 0 3.414.586S19 5.114 19 7v7.172c0 .408 0 .613-.076.797-.076.183-.22.328-.51.617l-4.828 4.828c-.29.29-.434.434-.617.51-.184.076-.389.076-.797.076Z" }),
            React.createElement("path", { stroke: "currentColor", d: "M12 21v-4.667c0-1.1 0-1.65.342-1.991.341-.342.891-.342 1.991-.342H19" })));
}
const BlankAltLight = forwardRef(_BlankAltLight);
export { BlankAltLight };
